import { Card } from '@/components/ui/card';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from '@/components/ui/select';
import { motion } from 'framer-motion';
import { Filter } from 'lucide-react';
import { ReactElement, useState } from 'react';

const TIME_PERIODS = [
  { value: 'today', label: 'Daily' },
  { value: '7days', label: 'Weekly' },
  { value: '30days', label: 'Monthly' },
];

export const MarketingFunnelCard = (): ReactElement => {
  const [timePeriod, setTimePeriod] = useState('7days');

  return (
    <Card className="p-5 h-max w-full">
      <div className="flex flex-col gap-2">
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <div className="flex justify-between items-center">
            <h2 className="text-lg font-semibold">Marketing Funnel</h2>
            <Select value={timePeriod} onValueChange={setTimePeriod}>
              <SelectTrigger className="w-14 h-10 px-2">
                <Filter className="h-4 w-4 mr-2" />
              </SelectTrigger>
              <SelectContent align="end">
                {TIME_PERIODS.map((period) => (
                  <SelectItem key={period.value} value={period.value}>
                    {period.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </motion.div>

        <div className="relative aspect-video rounded-lg overflow-hidden">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-full object-cover">
            <source src="/funnel.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </Card>
  );
};
